import type {FC} from 'react'
import React from "react";
import {DropTargetMonitor, useDrop} from 'react-dnd'
import {ElementoRMLSelezionabileRecord} from "@commons/mapping/ElementoRMLSelezionabileRecord";
import Elemento4Drag from "./Elemento4Drag";
import {ElementoRMLRecord} from "@commons/mapping/ElementoRMLRecord";

export const DropZone: FC<{
    name: string,
    elementi: ElementoRMLSelezionabileRecord[],
    setElementiSelezionabili: React.Dispatch<React.SetStateAction<ElementoRMLSelezionabileRecord[]>>,
    setElementiSelezionati: React.Dispatch<React.SetStateAction<ElementoRMLSelezionabileRecord[]>>,
    onDrop: (arg: any, monitor: DropTargetMonitor) => void,
    accept: string,
    type: string,
}> = ({
          name,
          elementi,
          setElementiSelezionabili,
          setElementiSelezionati,
          onDrop,
          accept,
          type,
      }) => {


    const [{canDrop, isOver}, drop] = useDrop(() => ({
        accept: accept,
        //drop: () => ({name}),
        drop: (item, monitor) => onDrop(item, monitor),
        collect: (monitor) => ({
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop(),
        }),
    }))

    const isActive = canDrop && isOver
    let backgroundColor = 'bg-gray-50';
    if (isActive) {
        backgroundColor = 'bg-amber-100'
    } else if (canDrop) {
        backgroundColor = 'bg-amber-200'
    }

    /**
     * Ordina per peso ordinamento e descrizione
     * @param a
     * @param b
     */
    const compareElementi = (a: ElementoRMLRecord, b: ElementoRMLRecord) => {
        if (a.sortOrder === b.sortOrder) {
            return a.descrizione!.localeCompare(b.descrizione!);
        } else return a.sortOrder < b.sortOrder ? -1 : 1;
    }

    return (
        <div ref={drop} className={`px-5 py-3 lg:px-8 lg:py-6 h-full scrollbar-thin scrollbar-thumb-gray-500 scrollbar-track-gray-200 overflow-y-scroll ${backgroundColor}`}
             data-testid={name}>
            <div className="text-center font-medium mb-4 text-blue-700">
                {isActive ? 'Rilascia qui' : 'Trascina qui'}
            </div>
            <div className="text-lg">
                {elementi && elementi.sort(compareElementi).map((item, index) => (
                    <Elemento4Drag key={item.codElemento} elemento={item} type={type} setElementiSelezionabili={setElementiSelezionabili}
                                   setElementiSelezionati={setElementiSelezionati}/>
                ))}
            </div>
        </div>
    )
}

export default DropZone;